<template>
  <ProgressRoot :model-value="null" class="progress-bar" :class="`is-${size}`">
    <ProgressIndicator class="progress-bar__indicator" />
  </ProgressRoot>
</template>

<script>
import { ProgressIndicator, ProgressRoot } from 'reka-ui'

export default {
  name: 'ProgressBar',
  components: { ProgressRoot, ProgressIndicator },
  props: {
    size: {
      type: String,
      default: 'small',
      validator: (v) => ['small', 'medium', 'large'].includes(v),
    },
  },
}
</script>

<style lang="scss" scoped>
.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  background-color: hsla(
    var(--bulma-primary-h),
    var(--bulma-primary-s),
    var(--bulma-primary-l),
    0.15
  );

  &.is-small {
    height: var(--space-1);
  }
  &.is-medium {
    height: var(--space-2);
  }
  &.is-large {
    height: var(--space-6);
  }
}

.progress-bar__indicator {
  height: 100%;
  width: 40%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    hsl(var(--bulma-primary-h), var(--bulma-primary-s), var(--bulma-primary-l))
      50%,
    transparent 100%
  );
  animation: shimmer 1.2s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(350%);
  }
}
</style>
